module.exports = __webpack_public_path__ + "img/lu.1ac4d60f.svg";